import { error, finish } from 'src/modules/market-templates/actions/update';
import { request as getList } from './get-list';

export function request(dispatch, { id, sportId, eventTemplateId, data }) {

    if (data.cashoutMarketSettings) {
        for (const value in data.cashoutMarketSettings) {
            data.cashoutMarketSettings[value] = Math.round(data.cashoutMarketSettings[value] * 100, 2);
        }
    }
    const numericFields = ['inPlayDelay', 'eachWayStakeReduction'];


    $appState.sdkStaff.patchMarketTemplate({
        requestBody: {
            data,
            sportId,
            eventTemplateId,
            marketTemplateId: id
        }
    }).then(marketTemplate => {
        if (data.allowedInMultiplesWith) {
            getList(dispatch, { sportId });
        }

        dispatch(finish(id, marketTemplate));
    });
}
